import {Component, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import {DialogData} from '../confirm-dialog.component';
import {CdkScrollable} from '@angular/cdk/scrolling';

import {MatButton} from '@angular/material/button';

@Component({
  selector: 'pub-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss'],
  standalone: true,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton]
})
export class UploadDialogComponent {
  selectedFile: File | null = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, public dialogRef: MatDialogRef<UploadDialogComponent>) {
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.selectedFile = input.files[0];
    }
  }

  onConfirm(): void {
    this.dialogRef.close(this.selectedFile);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
